
import { Component, Vue } from 'vue-property-decorator'
import { RequestPaging } from '@/utils/util'
import lsPagination from '@/components/ls-pagination.vue'
import {
  apiAliyunLiveLists,
  apiAliyunLiveDel,
  apiAliyunLiveDetail,
  apiAliyunLiveStatus,
  apiAliyunLiveRefreshUrl
} from '@/api/shop'

@Component({
  components: { lsPagination }
})
export default class AliyunLivePlatformLists extends Vue {
  pager: RequestPaging = new RequestPaging()
  searchObj: any = {}
  detailVisible = false
  detailData: any = null

  created() {
    this.getLists()
  }

  formatTime(timestamp: number) {
    if (!timestamp) return '-'
    const d = new Date(timestamp * 1000)
    const pad = (n: number) => String(n).padStart(2, '0')
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`
  }

  getLists(page?: number) {
    page && (this.pager.page = page)
    this.pager.request({
      callback: apiAliyunLiveLists,
      params: this.searchObj
    })
  }

  resetSearch() {
    this.searchObj = {}
    this.pager.page = 1
    this.getLists()
  }

  async onDetail(row: any) {
    try {
      const res: any = await apiAliyunLiveDetail({ id: row.id })
      this.detailData = res
      this.detailVisible = true
    } catch (e) {
      // handled by axios interceptor
    }
  }

  onDelete(row: any) {
    this.$confirm('确定删除该直播间？', '提示', { type: 'warning' })
      .then(() => {
        apiAliyunLiveDel({ id: row.id }).then(() => {
          this.$message.success('删除成功')
          this.getLists()
        })
      })
      .catch(() => {})
  }

  onForbid(row: any) {
    this.$confirm('确定禁播该直播间？', '提示', { type: 'warning' })
      .then(() => {
        apiAliyunLiveStatus({ id: row.id, status: 3 }).then(() => {
          this.$message.success('已禁播')
          this.getLists()
        })
      })
      .catch(() => {})
  }

  onResume(row: any) {
    apiAliyunLiveStatus({ id: row.id, status: 0 }).then(() => {
      this.$message.success('已恢复')
      this.getLists()
    })
  }

  onRefreshUrl(row: any) {
    apiAliyunLiveRefreshUrl({ id: row.id }).then(() => {
      this.$message.success('地址已刷新')
      this.getLists()
    })
  }
}
